import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

import { consentServices } from '@/lib/consent/registry'

function applyConsent() {
  const cookiebot = window.Cookiebot
  if (!cookiebot || !cookiebot.hasResponse || !cookiebot.consent) return

  consentServices.forEach((service) => {
    if (cookiebot?.consent?.[service.category]) {
      service.init()
    }
  })
}

export default function CookieConsentBanner() {
  const location = useLocation()

  useEffect(() => {
    applyConsent()

    window.addEventListener('CookiebotOnConsentReady', applyConsent)
    window.addEventListener('CookiebotOnAccept', applyConsent)

    return () => {
      window.removeEventListener('CookiebotOnConsentReady', applyConsent)
      window.removeEventListener('CookiebotOnAccept', applyConsent)
    }
  }, [])

  useEffect(() => {
    const path = `${location.pathname}${location.search}${location.hash}`
    consentServices.forEach((service) => service.trackPageView?.(path))
    // Ad-blockers / browser shields sometimes leave window.Cookiebot defined as
    // a partial stub without runScripts() — `?.` doesn't catch that.
    if (typeof window.Cookiebot?.runScripts === 'function') {
      window.Cookiebot.runScripts()
    }
  }, [location.pathname, location.search, location.hash])

  return null
}
